/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityAssetsDomainDnsRecordAnswer
 */
export interface MonitEntityAssetsDomainDnsRecordAnswer {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetsDomainDnsRecordAnswer
     */
    answer?: string;
}

/**
 * Check if a given object implements the MonitEntityAssetsDomainDnsRecordAnswer interface.
 */
export function instanceOfMonitEntityAssetsDomainDnsRecordAnswer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityAssetsDomainDnsRecordAnswerFromJSON(json: any): MonitEntityAssetsDomainDnsRecordAnswer {
    return MonitEntityAssetsDomainDnsRecordAnswerFromJSONTyped(json, false);
}

export function MonitEntityAssetsDomainDnsRecordAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetsDomainDnsRecordAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
    };
}

export function MonitEntityAssetsDomainDnsRecordAnswerToJSON(value?: MonitEntityAssetsDomainDnsRecordAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answer': value.answer,
    };
}

